import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import userReducer from './slices/authSlice';
import strainDataReducer from './slices/strainDataSlice';
import recoveryDataReducer from './slices/recoveryDataSlice';
import averageStrainReducer from './slices/averageStrainSlice';
import averageRecoveryReducer from './slices/averageRecoverySlice';
import averageSleepReducer from './slices/averageSleepSlice';
import averageFleetReducer from './slices/averageFleetSlice';
import selectedVesselIdReducer from './slices/selectedVesselIdSlice';

export const store = configureStore({
    reducer: {
        user: userReducer,
        strain: strainDataReducer,
        recovery: recoveryDataReducer,
        averageStrain: averageStrainReducer,
        averageRecovery: averageRecoveryReducer,
        averageSleep: averageSleepReducer,
        averageFleetDetails: averageFleetReducer,
        selectedVesselId: selectedVesselIdReducer
    } 
});

export type TStore = ReturnType<typeof store.getState>;
export default store;
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()